<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
    <div v-for="button in buttons" :key="button.id">
      <strapi-button :component="button" :size="'small'" class="w-full" />
    </div>
    <!-- social media buttons go here -->
  </div>
</template>

<script setup lang="ts">
import type { StrapiButton } from '#variant/apollo/types/types';

const props = withDefaults(
  defineProps<{
    buttons: Array<StrapiButton>;
  }>(),
  {
    buttons: () => [],
  },
);
</script>
